import React,{Component} from 'react'
import {Route,Switch,Redirect} from 'react-router-dom';
import './style.less'
import asyncComponent from '../../utils/AsyncComponent'


const QuestionBankSummary=asyncComponent(()=>import('./index/view.js'))
const QuestionDetail=asyncComponent(()=>import('./question_quantity/question_detail/view.js'))
// const QuestionBankTrend=asyncComponent(()=>import('./question_quantity/question_bank_trend/view.js'))
const ChapterCover=asyncComponent(()=>import('./question_quantity/chapter_cover/view.js'))
const PointCover=asyncComponent(()=>import('./question_quantity/point_cover/view.js'))
const VarietyData=asyncComponent(()=>import('./question_quantity/variety_data/view.js'))
const AssignAnswer=asyncComponent(()=>import('./user_data/assign_answer/view.js'))
const taskDistributed=asyncComponent(()=>import('./user_data/task_distributed/view.js'))


class Content extends Component{
    render(){
        return (
            <div className="contentContainer ">
                <Switch >
                    <Route path="/" exact component={QuestionBankSummary}/>
                    <Route path="/index" exact component={QuestionBankSummary}/>
                    <Route path="/questionquantity/questiondetail" exact component={QuestionDetail}/>
                    {/* <Route path="/questionquantity/questionbanktrend" exact   component={QuestionBankTrend}/> */}
                    <Route path="/questionquantity/chaptercover" exact  component={ChapterCover}/>
                    <Route path="/questionquantity/pointCover" exact  component={PointCover}/>
                    <Route path="/questionquantity/varietyData" exact  component={VarietyData}/>
                    <Route path="/user_data/assign_answer" exact  component={AssignAnswer}/>
                    <Route path="/user_data/task_distributed" exact  component={taskDistributed}/>
                    <Redirect from="/http://127.0.0.1" to="/" />
                </Switch>
            </div>
        )
    }
}
export default Content;


// WEBPACK FOOTER //
// ./src/app/content/view.js